import classNames from 'clsx';
import React, { type VFC } from 'react';
import { useSelector } from 'react-redux';
import { multiTariffSpaceToEachFamilyMember } from 'reactApp/appHelpers/featuresHelpers/features/multiTariff';
import { tariffCardPersonal } from 'reactApp/appHelpers/featuresHelpers/features/tariifCardPersonal';
import { useFamilyShowFeaturesHook } from 'reactApp/hooks/useFamilyShowHook';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

import styles from './TariffSpace.css';
import type { ITariffSpaceProps } from './TariffSpace.types';

export const TariffSpace: VFC<ITariffSpaceProps> = ({
    dataQa,
    space,
    units,
    giftSpace,
    giftKind,
    showSpaceWithPlus,
    contentSize = 'middle',
    isRebrandingQuotaLanding = false,
    isRebranding = false,
    className,
    spaceClassName,
    unitsClassName,
    isVigboTariff = false,
    isFamilyTariff = false,
}) => {
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const isFamilyUser = useFamilyShowFeaturesHook();
    const familySpaceToEachCheckUser = multiTariffSpaceToEachFamilyMember && !isFamilyUser && !isOverquota;

    return (
        <div
            className={classNames(styles.space, className, {
                [styles.space_withGift]: Boolean(giftSpace),
                [styles.space_rebrandingQuotaLanding]: isRebrandingQuotaLanding,
                // tempexp_18084-next-line
                [styles.space_personal]: tariffCardPersonal === 'c',
                [styles.space_vigbo]: isVigboTariff,
                [styles.space_family]: isFamilyTariff,
                [styles.space_familySpaceToEach]: isFamilyTariff && familySpaceToEachCheckUser,
            })}
            data-qa={dataQa}
        >
            <div
                className={classNames(styles.spaceName, {
                    [styles[`contentSize_${contentSize}`]]: contentSize,
                    [styles.spaceName_rebranding]: isRebranding,
                    [styles.vigboColor]: isVigboTariff,
                    [styles.spaceName_vigbo]: isVigboTariff,
                    [styles.spaceName_family]: isFamilyTariff,
                })}
                data-qa={dataQa && 'volume'}
            >
                {!giftSpace && showSpaceWithPlus && '+'}
                <span
                    className={classNames(styles.spaceSize, spaceClassName, {
                        [styles.spaceSize_vigbo]: isVigboTariff,
                        [styles.spaceSize_family]: isFamilyTariff,
                    })}
                >
                    {space}
                </span>
            </div>
            <div
                className={classNames(styles.spaceUnits, unitsClassName, {
                    [styles[`contentSize_${contentSize}`]]: contentSize,
                    [styles.spaceUnits_rebranding]: isRebranding,
                    [styles.vigboColor]: isVigboTariff,
                    [styles.spaceUnits_vigbo]: isVigboTariff,
                    [styles.spaceUnits_family]: isFamilyTariff,
                })}
                data-qa={dataQa && 'units'}
            >
                {units}
            </div>
            {giftSpace && (
                <div
                    className={classNames(styles.gift, {
                        [styles[`gift_${giftKind}`]]: Boolean(giftKind),
                    })}
                >
                    <div className={styles.plus}>+</div>
                    <div className={styles.spaceName} data-qa={dataQa && 'gift-volume'}>
                        {giftSpace.space}
                    </div>
                    <div className={styles.spaceUnits} data-qa={dataQa && 'gift-units'}>
                        * {giftSpace.units}
                    </div>
                </div>
            )}
        </div>
    );
};
